var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b08ee4d575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03d472df14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.539062 0 L 12.460938 0 C 10.855469 0 9.554688 1.300781 9.554688 2.902344 L 9.554688 6.167969 C 9.554688 7.773438 8.257812 9.074219 6.652344 9.074219 L 3.386719 9.074219 C 1.785156 9.074219 0.484375 10.371094 0.484375 11.976562 L 0.484375 17.054688 C 0.484375 18.660156 1.785156 19.960938 3.386719 19.960938 L 6.652344 19.960938 C 8.257812 19.960938 9.554688 21.257812 9.554688 22.863281 L 9.554688 26.128906 C 9.554688 27.734375 10.855469 29.03125 12.460938 29.03125 L 17.539062 29.03125 C 19.144531 29.03125 20.445312 27.734375 20.445312 26.128906 L 20.445312 22.863281 C 20.445312 21.257812 21.742188 19.960938 23.347656 19.960938 L 26.613281 19.960938 C 28.214844 19.960938 29.515625 18.660156 29.515625 17.054688 L 29.515625 11.976562 C 29.515625 10.371094 28.214844 9.074219 26.613281 9.074219 L 23.347656 9.074219 C 21.742188 9.074219 20.445312 7.773438 20.445312 6.167969 L 20.445312 2.902344 C 20.445312 1.300781 19.144531 0 17.539062 0 Z M 17.539062 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b08ee4d575)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03d472df14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9397ab",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.725806, 0, 0, 0.725806, 0.48387, 0.00000193548)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 23.498265 -0.00000266667 L 16.501737 -0.00000266667 C 14.289758 -0.00000266667 12.49757 1.792185 12.49757 3.998782 L 12.49757 8.498088 C 12.49757 10.710067 10.710765 12.502254 8.498785 12.502254 L 3.99948 12.502254 C 1.792883 12.502254 0.000695111 14.28906 0.000695111 16.501039 L 0.000695111 23.497567 C 0.000695111 25.709546 1.792883 27.501734 3.99948 27.501734 L 8.498785 27.501734 C 10.710765 27.501734 12.49757 29.288539 12.49757 31.500518 L 12.49757 35.999824 C 12.49757 38.211803 14.289758 39.998609 16.501737 39.998609 L 23.498265 39.998609 C 25.710244 39.998609 27.502431 38.211803 27.502431 35.999824 L 27.502431 31.500518 C 27.502431 29.288539 29.289237 27.501734 31.501216 27.501734 L 36.000522 27.501734 C 38.207119 27.501734 39.999307 25.709546 39.999307 23.497567 L 39.999307 16.501039 C 39.999307 14.28906 38.207119 12.502254 36.000522 12.502254 L 31.501216 12.502254 C 29.289237 12.502254 27.502431 10.710067 27.502431 8.498088 L 27.502431 3.998782 C 27.502431 1.792185 25.710244 -0.00000266667 23.498265 -0.00000266667 Z M 23.498265 -0.00000266667 ",
    stroke: "#ffffff",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.daa2ae16c558932fbb8c69b15d6246d1.svg";
export { ForwardRef as ReactComponent };